import { useEffect, useRef, useState } from 'react';

// Tracks whether a horizontally-scrollable element has been scrolled away
// from its left edge, so a UI cue (eg. a sticky column's divider) can show
// only once content is actually scrolled underneath it.
export const useHorizontalScrollShadow = () => {
    const scrollRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const updateScrolled = () => setIsScrolled(el.scrollLeft > 0);
        updateScrolled();

        el.addEventListener('scroll', updateScrolled, { passive: true });
        return () => el.removeEventListener('scroll', updateScrolled);
    }, []);

    return { scrollRef, isScrolled };
};
